import { c as _c } from "react/compiler-runtime";
import { useCompanyId } from "@context-providers/company-id-provider";
import { useErrorContext } from "@context-providers/error-boundary/error-handling-context";
import { Button, Tooltip } from "@flat-ui";
import { generateCreditsFullRoute, generateCreditsPurchaseRedirectFullRoute } from "@router/router-helper";
import { CREDITS_BALANCE, CREDITS_DISPLAY_NAME } from "@src/constants/credit-constants";
import { runtimeConfig } from "@src/runtime-config";
import { useIsStripePurchaseEnabled } from "@hooks/use-credit-packages";
import { companyCreditBalanceSelector } from "@store/sdb-company/sdb-company-selector";
import { useAppSelector } from "@store/store-helper";
import { WorkspaceEvents } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { useState } from "react";
/** Renders credit purchase button and redirect to checkout session */
export function CreditPurchase(t0) {
  const $ = _c(13);
  const {
    selectedPackage
  } = t0;
  const companyId = useCompanyId();
  const {
    trackEvent
  } = useTrackEvent();
  const {
    handleErrorWithToast
  } = useErrorContext();
  const companyCreditBalance = useAppSelector(companyCreditBalanceSelector);
  const isStripePurchaseEnabled = useIsStripePurchaseEnabled();
  const [isCheckoutLoading, setIsCheckoutLoading] = useState(false);
  let t1;
  if ($[0] !== companyCreditBalance || $[1] !== companyId || $[2] !== handleErrorWithToast || $[3] !== selectedPackage || $[4] !== trackEvent) {
    t1 = function onPurchaseClick() {
      trackEvent({
        name: WorkspaceEvents.initiatePurchaseCredits,
        props: {
          tokenPackage: selectedPackage ?? "-"
        }
      });
      if (!selectedPackage) {
        handleErrorWithToast({
          id: `onPurchaseClick-${Date.now().toString()}`,
          title: "Please select a token package",
          error: new Error("Package is not selected")
        });
        return;
      }
      setIsCheckoutLoading(true);
      localStorage.setItem(CREDITS_BALANCE, companyCreditBalance.toString());
      const payload = {
        stripeProductId: selectedPackage.id,
        workspaceId: companyId,
        successUrl: generateCreditsPurchaseRedirectFullRoute(companyId),
        cancelUrl: generateCreditsFullRoute(companyId),
        relyOnUserForBillingEmail: true
      };
      const form = document.createElement("form");
      form.action = `${runtimeConfig.urls.apiBaseUrl}/stripe/product/checkout-session`;
      form.method = "POST";
      form.style.display = "none";
      Object.entries(payload).forEach(t2 => {
        const [name, value] = t2;
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = name;
        input.value = String(value);
        form.appendChild(input);
      });
      document.body.appendChild(form);
      form.submit();
    };
    $[0] = companyCreditBalance;
    $[1] = companyId;
    $[2] = handleErrorWithToast;
    $[3] = selectedPackage;
    $[4] = trackEvent;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const onPurchaseClick = t1;
  if (!isStripePurchaseEnabled) {
    return;
  }
  const t2 = !selectedPackage ? "Please select a package to purchase." : "";
  const t3 = !selectedPackage;
  let t4;
  if ($[6] !== isCheckoutLoading || $[7] !== onPurchaseClick || $[8] !== t3) {
    t4 = <Button fullWidth={true} onClick={onPurchaseClick} disabled={t3} isLoading={isCheckoutLoading}>Purchase {CREDITS_DISPLAY_NAME}</Button>;
    $[6] = isCheckoutLoading;
    $[7] = onPurchaseClick;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t2 || $[11] !== t4) {
    t5 = <Tooltip component="div" title={t2}>{t4}</Tooltip>;
    $[10] = t2;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}